import { CustomerIOEvent, PayeeType } from 'lib/type/enums';
import { trackCustomerIOEvent } from 'utils/customerIO';
import { useCreatePayeeMutation } from 'lib/services/payee';

interface CreatePayeeProps {
    name: string;
    type: PayeeType;
    accountNumber: string;
    sortCode: string;
}

export const useCreatePayee = () => {
    const [
        createPayeeMutation,
        { error, isLoading, isSuccess },
    ] = useCreatePayeeMutation();
    const handleCreatePayee = async (data: CreatePayeeProps) => {
        const { name: payeeName, type } = data;
        try {
            await createPayeeMutation(data).unwrap();
            trackCustomerIOEvent(CustomerIOEvent.CREATE_PAYEE, {
                payeeName,
                type,
            });
        } catch (error) {
            console.error('Error creating payee:', error);
        }
    };

    return {
        handleCreatePayee,
        isLoading,
        isSuccess,
        error,
    };
};
